import styled from '@emotion/styled'
import { memo } from 'react'
import { getModelColor } from '../../../../../utilities/colors'
import {
    AppStateType,
    useAppStateSelector,
} from '../../../../Hooks/useAppState'
import { useUserSelector } from '../../../../Hooks/useUser'
import { GridColumn, GridContainer } from '../../../../common/Layout'
import { getThemeSpacing } from '../../../../styles/appTheme'
import { palette } from '../../../../styles/colors'
import CounterViewers from '../../../CounterViewers'

const DivRoot = styled('div')({
    padding: getThemeSpacing(2),
})

const DivTitle = styled('div')({
    color: palette.primary,
    fontWeight: 600,
    display: 'inline-flex',
    alignItems: 'center',
})

const StyledViewerWrapper = styled('span')({
    paddingLeft: getThemeSpacing(1),
})

const DivParticipantName = styled('div')({
    fontWeight: 600,
    padding: `${getThemeSpacing(1)} ${getThemeSpacing(2)}`,
})

interface IParticipantName {
    id: number
}

const ParticipantName = memo(({ id }: IParticipantName) => {
    const name = useUserSelector(id, 'name')
    const color = useUserSelector(id, 'color')

    const darkMode = useAppStateSelector(AppStateType.APP, 'darkMode')
    const nameColor = getModelColor(color, darkMode)
    return (
        <DivParticipantName style={{ color: nameColor }}>
            {name}
        </DivParticipantName>
    )
})

interface IParticipants {
    uid: number
}

const Participants = memo(({ uid }: IParticipants) => {
    const participants = useUserSelector(uid, 'participants') || []

    if (!participants.length) {
        return null
    }

    return (
        <DivRoot>
            <DivTitle>
                Participants{' '}
                <StyledViewerWrapper>
                    <CounterViewers viewers={participants.length} size={0.7} />
                </StyledViewerWrapper>
            </DivTitle>
            <GridContainer>
                {participants.map((id) => (
                    <GridColumn key={id}>
                        <ParticipantName key={id} id={id} />
                    </GridColumn>
                ))}
            </GridContainer>
        </DivRoot>
    )
})

export default Participants
